import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

export const useSsrWindowSize = () => {
    const actualWindowSize = useWindowSize();

    const [windowSize, setWindowSize] = useState<{
        width: number | undefined;
        height: number | undefined;
    }>({ width: undefined, height: undefined });

    useEffect(() => {
        setWindowSize(actualWindowSize);
    }, [actualWindowSize]);

    return windowSize;
};

export const useSsr = (callback?: () => void) => {
    const [isServer, setIsServer] = useState(true);

    useEffect(() => {
        setIsServer(false);
        callback?.();
    }, [callback]);

    return { isServer };
};
